var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-editor"},[_c('base-textarea',{ref:"editor",staticClass:"editor",attrs:{"placeholder":_vm.$t('askMe.questionForm.placeholder') + '*'},model:{value:(_vm.questionText),callback:function ($$v) {_vm.questionText=$$v},expression:"questionText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }